import Id from './Id';
import RepresentativeUser from './RepresentativeUser';
import Location from './Location';
import ShopId from './ShopId';
import Shop from './Shop';
import PostalCode from './PostalCode';
import City from './City';
import Street from './Street';
import Date from './Date';
import Enter from './Enter';
import Exit from './Exit';
import VisitTime from './VisitTime';
import CashNetPrice from './CashNetPrice';
import TransferNetPrice from './TransferNetPrice';
import PlacementNetPrice from './PlacementNetPrice';
import FailureReason from "./FailureReason";


export const labels = {
  Id: 'Id',
  RepresentativeUser: 'Képviselő',
  Location: 'Terület',
  ShopId: 'Bolt azonosító',
  Shop: 'Üzlet',
  PostalCode: 'Irsz.',
  City: 'Város',
  Street: 'Utca',
  Date: 'Dátum',
  Enter: 'Boltba belépés',
  Exit: 'Boltból kilépés',
  VisitTime: 'Látogatás hossza',
  CashNetPrice: 'Nettó értékesítés',
  TransferNetPrice: 'Nettó kiszámlázás',
  PlacementNetPrice: 'Nettó kihelyezés',
  FailureReason: 'Meghiusulás oka',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'RepresentativeUser',
}, {
  value: 'Location',
}, {
  value: 'ShopId',
}, {
  value: 'Shop',
}, {
  value: 'PostalCode'
}, {
  value: 'City',
}, {
  value: 'Street'
}, {
  value: 'Date',
}, {
  value: 'Enter'
}, {
  value: 'Exit',
}, {
  value: 'VisitTime'
}, {
  value: 'CashNetPrice'
}, {
  value: 'TransferNetPrice'
}, {
  value: 'PlacementNetPrice'
}, {
  value: 'FailureReason'
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'RepresentativeUser',
}, {
  value: 'Location',
}, {
  value: 'ShopId',
}, {
  value: 'Shop',
}, {
  value: 'PostalCode'
}, {
  value: 'City',
}, {
  value: 'Street'
}, {
  value: 'Date',
}, {
  value: 'Enter'
}, {
  value: 'Exit',
}, {
  value: 'VisitTime'
}, {
  value: 'CashNetPrice'
}, {
  value: 'TransferNetPrice'
}, {
  value: 'PlacementNetPrice'
}, {
  value: 'FailureReason'
}];

export const defaultSort = {
  prop: Id.propName,
  order: 'descending'
};

export default {
  Id,
  RepresentativeUser,
  Location,
  ShopId,
  Shop,
  PostalCode,
  City,
  Street,
  Date,
  Enter,
  Exit,
  VisitTime,
  CashNetPrice,
  TransferNetPrice,
  PlacementNetPrice,
  FailureReason,
};
